import type { ConsignmentAccountingSource, AccountingRole } from './consignment-accounting';

export interface BookkeepingSelection {
  consignorId: string;
  month: string;
  statementIds: string[];
}
export interface BookkeepingSource extends ConsignmentAccountingSource {
  statementId: string;
  sourceFingerprint: string;
  priorPeriod: boolean;
}
export interface BookkeepingPreview extends BookkeepingSelection {
  fingerprint: string;
  generatedAt: string;
  sources: BookkeepingSource[];
  excluded: Array<{ sourceId: string; packetId: string }>;
  statementVersions: Array<{ statementId: string; version: number; financeVersion: number }>;
  totals: Partial<Record<AccountingRole, number>>;
  issues: string[];
  limitations: string[];
}
export const BOOKKEEPING_EVIDENCE = {
  priorEntries: 'Prior accounting entries checked',
  marketplace: 'eBay transactions, fees and payouts',
  bank: 'Bank and external payment evidence',
  treatment: 'Shipping, tax, refund and fee treatment',
} as const;
export type BookkeepingEvidence = Record<keyof typeof BOOKKEEPING_EVIDENCE, string>;
export interface BookkeepingPacket extends BookkeepingPreview {
  packetId: string;
  status: 'PREPARED' | 'RECORDED' | 'CANCELED';
  createdAt: string;
  createdBy: string;
  recorded?: {
    at: string;
    actor: string;
    company: string;
    documentReference: string;
    postingDate: string;
    evidence: BookkeepingEvidence;
  };
  canceled?: { at: string; actor: string; reason: string };
}
export type BookkeepingMutation =
  | ({ operation: 'PREVIEW_BOOKKEEPING' } & BookkeepingSelection)
  | ({
      operation: 'PREPARE_BOOKKEEPING';
      requestId: string;
      fingerprint: string;
    } & BookkeepingSelection)
  | {
      operation: 'RECORD_BOOKKEEPING';
      consignorId: string;
      packetId: string;
      company: string;
      documentReference: string;
      postingDate: string;
      evidence: BookkeepingEvidence;
      enteredExternally: boolean;
    }
  | { operation: 'CANCEL_BOOKKEEPING'; consignorId: string; packetId: string; reason: string };
